import { ENGLISH } from './english';
import { HINDI } from './hindi';
const lang = { ENGLISH, HINDI };
export default lang;